// eslint-disable-next-line no-unused-vars
import Headroom from "headroom.js";
// eslint-disable-next-line no-unused-vars
import lity from "lity";
// eslint-disable-next-line no-unused-vars
import Sticky from "sticky-kit/dist/sticky-kit.js";

export default {
  init() {

    $(document).on(
      "click",
      "header .navbar-toggler",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("mm-menu-open");
        $("header #crw-nav-icon").toggleClass("open");
      }
    );

    // Auto append links with target="_blank" if the link is not part of the network.
    $(document).find('.main-page-wrap a[href^="http"]').each(function(){
      var href = $(this).attr('href');
      var button = $(this);
      var network_home = $('body').attr('data-nh');
      if ( ! href.includes( network_home ) && undefined === button.attr('target') ) {
        $(this).attr('target', '_blank');
      }
    });


    var options = {
    // or you can specify offset individually for up/down scroll
      offset: 30,
    // scroll tolerance in px before state changes
      tolerance : {
        up: 0,
        down: 0,
      },
    // css classes to apply
    };

    // JavaScript to be fired on all pages
    const scroll_to_top = document.querySelector(".crw-header");
    if ( scroll_to_top ) {
      const headroom = new Headroom(scroll_to_top, options);
      headroom.init();
    }

    // Mobile sidebar navigation
    $(document).on("click", ".crw-sidebar .crw-sidebar-nav", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const nav = $(this);
      const navWidget = $(".crw-sidebar .crw-nav-widget");
      const isOpen = nav.toggleClass("open").hasClass("open");
      navWidget.toggleClass("open", isOpen);
    });

    // Smooth scroll to section
    $('.crw-nav-widget .nav-widget-list a[href^="#"]').on('click', function (e) {
      e.preventDefault();

      const $targetEle = $(this.hash);

      if ($targetEle.length) {
        $('html, body').stop().animate({
          scrollTop: $targetEle.offset().top - 148,
        }, 1000, 'swing');
      }
    });

    $(document).find("header.crw-header.v2 li.has-megamenu").on({
      mouseenter: function () {
        if ( $(this).hasClass('has-megamenu') ) {
          $('header.crw-header.v2').addClass('crw-menu-open');
        }
      },
      mouseleave: function () {
        $('header.crw-header.v2').removeClass('crw-menu-open');
        if ( $(this).hasClass('has-megamenu') ) {
          $('header.crw-header.v2').removeClass('crw-menu-open');
        }
      },
    });

    if ($(window).width() > 767) {
      $(document).on('mouseenter', 'header.crw-header.v2 .mega-menu-tabs .nav-item .nav-link', function(e) {
        e.preventDefault();

        const targetId = $(this).attr('href');

        $(this).closest('.mega-menu-tabs').find('.nav-link').removeClass('active');
        $(this).addClass('active');

        $(this).closest('.mega-sub-menu-wrap').find('.tab-pane').removeClass('show active');
        $(targetId).addClass('show active');
      });
    }

    // Mobile-specific functionality
    if ($(window).width() <= 767) {

      $(document).on('click', 'header.crw-header.v2 .navbar-toggler', function() {
        if ($('body').hasClass('mm-menu-open')) {
          $('#navbar-nav').addClass('show');
        }
      });

      $(document).on('click', '#crw-nav-icon-mobile', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $('#navbar-nav').removeClass('show');
        $('body').removeClass('mm-menu-open');
        $('#crw-nav-icon').removeClass('open');
        $('#crw-nav-icon-close').removeClass('open');
        $('.mega-sub-menu').removeClass('active');
      });

      $(document).on('click', 'header.crw-header.v2 .menu-item.has-megamenu > a', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).siblings('.mega-sub-menu').addClass('active');
      });

      $(document).on('click', 'header.crw-header.v2 .mobile-back-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.mega-sub-menu').removeClass('active');
      });
    }

    $(window).on('resize', function() {
      if ($(window).width() > 767) {
        $('#navbar-nav').removeClass('show');
        $('.mega-sub-menu').removeClass('active');
        $('body').removeClass('crw-menu-open mm-menu-open');
        $('#crw-nav-icon').removeClass('open');
        $('#crw-nav-icon-mobile').removeClass('open');
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js